import requests from './httpService';

const PushNotificationService = {
  sendNotification(body) {
    return requests.post('/pushnotification/send', body);
  },
  listParentNotifications(params = {}) {
    const query = {};
    if (params.classId) query.classId = params.classId;
    if (params.year != null && params.year !== '') query.year = String(params.year);
    if (params.month != null && params.month !== '') query.month = String(params.month);
    return requests.get('/pushnotification/parent', { params: query });
  },
  listAdminNotifications() {
    return requests.get(`/pushnotification/admin`);
  },
  updateAdminNotification(id, body) {
    return requests.put(`/pushnotification/admin/${id}`, body);
  },
  deleteAdminNotification(id) {
    return requests.delete(`/pushnotification/admin/${id}`);
  },
};

export default PushNotificationService;

